import React from "react";
import { Card, Form, Button, Col, Spinner } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { showSuccessToast } from "utils/toast";
import { useDispatch } from "react-redux";

import { LEAVE_STATUS } from "constants";
import { setStatus as setStatusInStore } from "state/slices/requestleave/requestLeaveSlice";
import { useUpdateRequestLeaveMutation } from "state/slices/requestleave/requestLeaveApiSlice";

const ManageStatus = ({ statusData, onStatusUpdate }) => {
  const dispatch = useDispatch();
  const [updateRequestLeave] = useUpdateRequestLeaveMutation();

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const updatedLeave = { id: statusData.id, status: values.status };
      await updateRequestLeave(updatedLeave).unwrap();

      dispatch(setStatusInStore(updatedLeave));
      showSuccessToast("Leave status updated successfully");

      if (typeof onStatusUpdate === "function") onStatusUpdate();
    } catch (error) {
      // Error toast is automatically shown by baseQuery
    } finally {
      setSubmitting(false);
    }
  };

  const validationSchema = Yup.object({
    status: Yup.string()
      .oneOf(Object.keys(LEAVE_STATUS))
      .required("Leave status is required"),
  });

  return (
    <Card>
      <Card.Body>
        <Formik
          enableReinitialize
          initialValues={{ status: statusData?.status || "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, handleChange, handleSubmit, touched, errors, isSubmitting }) => (
            <Form noValidate onSubmit={handleSubmit} className="row mt-3">
              <Col md={6}>
                <Form.Group controlId="status">
                  <Form.Control
                    as="select"
                    name="status"
                    value={values.status}
                    onChange={handleChange}
                    isInvalid={touched.status && !!errors.status}
                  >
                    <option value="">Select status</option>
                    {Object.entries(LEAVE_STATUS).map(([key, label]) => (
                      <option key={key} value={key}>
                        {label}
                      </option>
                    ))}
                  </Form.Control>
                  <Form.Control.Feedback type="invalid">
                    {errors.status}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Button
                  type="submit"
                  className="w-100"
                  variant="primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        role="status"
                        className="me-2"
                        style={{ width: "18px", height: "18px" }}
                      />
                      Updating...
                    </>
                  ) : (
                    "Update Status"
                  )}
                </Button>
              </Col>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default ManageStatus;